import React from "react";
import { Typography } from "@mui/material";

const TextContentWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Typography
      component="div"
      variant="body2"
      sx={{
        whiteSpace: "pre-wrap",
        overflowWrap: "break-word",
        wordBreak: "break-word",
      }}
    >
      {children}
    </Typography>
  );
};

export default TextContentWrapper;
